module.exports = __webpack_public_path__ + "static/final-c932e4c1b94d7f233b173d4eb1ad0627.png";